
import * as types from "../types/pinModal"

export const closePinModal = () => ({
  type: types.CLOSE_PIN_MODAL
})

export const openPinModal = () => ({
  type: types.OPEN_PIN_MODAL
})